import { useTranslation } from 'react-i18next';
import moment from 'moment';
import classnames from 'classnames';

import { BodySmallText } from '../typography/typography';
import { DATE_FORMAT, TIME_FORMAT } from '../../constants';
import CraneIcon from '../../assets/iconsComponent/CraneIcon';
import arrowRightIcon from '../../assets/icons/arrow-right.svg';
import { AssistanceNotificationStyle } from './assistance-notification-style';

//must be changed
interface AssistanceI {
  expectedTime?: string;
  onClick?: () => void;
  arrived?: boolean;
  text?: string;
  disabled?: boolean;
  canShowExpectedTime?: boolean;
  deferred?: string;
}
//expectedTime should be a date with hh:mm:ss and display the diference

const AssistanceNotification: React.FC<AssistanceI> = ({
  canShowExpectedTime,
  disabled,
  expectedTime,
  onClick,
  arrived,
  text,
  deferred,
}) => {
  const { t } = useTranslation(['assitance']);

  const getText = () => {
    if (arrived) return t('assistance:notification.arrived');
    if (deferred) return t('assistance:notification.deferred');
    if (text) return text;
    if (!expectedTime || !canShowExpectedTime) return t('assistance:notification.on-the-way');
    return t('assistance:notification.arriving-at');
  };
  return (
    <AssistanceNotificationStyle
      className={classnames({
        'assistance-arrived': arrived,
        'no-pointer-events': !onClick,
        disabled,
      })}
      onClick={() => (onClick ? onClick() : null)}
    >
      <CraneIcon className="assistance-icon" />
      <BodySmallText className="assistance-text">
        {getText()}
        {canShowExpectedTime && expectedTime && !deferred && (
          <span className="assistance-text--bold">{` ${expectedTime}`}</span>
        )}
        {deferred && (
          // eslint-disable-next-line max-len
          <span className="assistance-text--bold">{` ${moment(deferred).format(DATE_FORMAT)} - ${moment(deferred).format(TIME_FORMAT)}`}</span>
        )}
      </BodySmallText>
      <img
        className={classnames('assistance-arrow', {
          'show-arrow': onClick !== undefined && !disabled,
        })}
        src={arrowRightIcon}
        alt=""
      />
    </AssistanceNotificationStyle>
  );
};

export default AssistanceNotification;
